import i18n from "@/shared/config/i18n";
import { DefaultLayout } from "@/widgets/app-layout";
import EmptyRouterView from "@/pages/EmptyRouterView.vue";
import ClientCabinetList from "@/pages/admin/client_cabinet/ClientCabinetList.vue";
import ClientCabinetItem from "@/pages/admin/client_cabinet/ClientCabinetItem.vue";
import ClientAiChat from "@/pages/admin/client_cabinet/ClientAiChat.vue";
import EnforcementInscriptionItem from "@/pages/admin/enforcement_inscriptions/EnforcementInscriptionItem.vue";

const clientRoutes = [
  {
    path: "/",
    name: "default",
    role: "default",
    component: DefaultLayout,
    meta: {
      sourceRoot: true,
      isMain: true,
      title: i18n.global.t("Кабинет клиента"),
    },
    redirect: { name: "client_dashboard" },
    children: [
      {
        path: "client",
        name: "client",
        component: EmptyRouterView,
        meta: {
          title: i18n.global.t("Мои заявки"),
          icon: "huge-list-check",
          isDashboardItem: true,
        },
        redirect: { name: "client_dashboard" },
        children: [
          {
            path: "dashboard",
            name: "client_dashboard",
            component: ClientCabinetList,
            meta: {
              title: i18n.global.t("Просмотр"),
              isNavbarItem: true,
              isDashboardItem: true,
            },
          },
          {
            path: "document/:id",
            name: "client_document_view",
            component: ClientCabinetItem,
            meta: {
              title: i18n.global.t("Документ"),
              isNavbarItem: true,
              isDashboardItem: true,
            },
          },
          {
            path: "application/:id/edit",
            name: "client_application_edit",
            component: EnforcementInscriptionItem,
            meta: {
              title: i18n.global.t("Редактирование заявления"),
              isDashboardItem: false,
            },
          },
          {
            path: "application/:id",
            name: "client_application_view",
            component: EnforcementInscriptionItem,
            meta: {
              title: i18n.global.t("Заявление"),
              isDashboardItem: false,
            },
          },
        ],
      },
      {
        path: "ai-chat",
        name: "client_ai_chat",
        component: ClientAiChat,
        meta: {
          title: i18n.global.t("AI-ассистент"),
          icon: "huge-ai",
          isDashboardItem: true,
        },
      },
    ],
  },
];

export default clientRoutes;
